import React from 'react';
import { BadgeCheck } from 'lucide-react';

export default function VerifiedBadge({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  const sizeClass = size === 'md' ? 'text-sm px-3 py-1' : 'text-xs px-2 py-0.5';
  return (
    <span
      className={`council-badge ${sizeClass}`}
      title="This business has been verified by West Suffolk Council"
      aria-label="Council Verified"
    >
      <BadgeCheck size={size === 'md' ? 14 : 11} />
      Council Verified
    </span>
  );
}